var exports = {
  "m": "Octicon__QULrTL",
};

module.exports = exports;
